<mat-card>
  <mat-card-content>
    <mat-card-title>
      Bilanci 
    </mat-card-title>
  </mat-card-content>
</mat-card>
<mat-card class="p-0 card">
  <mat-card-content class="card-body">
    <input #fileInput type="file" accept=".pdf" (change)="changeListener($event)" />
    <br /><br />
    <button mat-raised-button color="primary"
            (click)="btnUpload()" cdkFocusInitial>
      CARICA
    </button>
  </mat-card-content>
</mat-card>


